import React, { useState } from 'react'
import { Header } from './Header'
import { Router } from '@reach/router'
import * as Pages from '../pages'
import { TokenList } from '../pages'
import { isMobileDevice } from '../helpers'
import { DesktopLayout } from './DesktopLayout'
import { MobileDeviceLayout } from './MobileDeviceLayout'
import { ScrollToTop } from './ScrollToTop'
import { GeoLocation, Slider, Toast } from '../components'
import { AdminOnlyRoute, PrivateRoute } from './PrivateRoute'
import { useSelector } from 'react-redux'
import DocumentTitle from './DocumentTitle'
import * as ReactBootstrap from 'react-bootstrap'
import { FlashList } from './Flash'

export const Canvas = () => {
  const { user } = useSelector((state) => state.auth)
  const { geoLocation, showHeader } = useSelector((state) => state.application)
  const { productName, idleTimeOutMinutes, idleTimeOutNoticeBeforeMinutes } =
    useSelector((state) => state.application)
  const [isMobileDeviceBrowser] = useState(isMobileDevice)

  if (!geoLocation) return <GeoLocation />

  return (
    <div className="body-contents vh-100">
      <DocumentTitle productName={productName} />
      <FlashList />
      {showHeader && <Header />}
      <Toast />
      <div className={'vh-100'}>
        {user && (
          <ReactBootstrap.Col className="pt-3 pr-2 text-end" xs="12">
            <div className="mb-2">
              <Slider
                variant="link"
                className="text-dark"
                title="Customer History"
              >
                <Pages.CustomersPage />
              </Slider>
              <TokenList />
            </div>
          </ReactBootstrap.Col>
        )}

        <Router primary={false} className={'vh-100'}>
          <ScrollToTop path="/">
            <Pages.Home path="/" />
            <Pages.LoginPage path="/login" postLoginPath="/dashboard" />
            <Pages.TokenEntryPage path="token/:locationCode" />
            <Pages.TokenEntryPage path="token/" />
            <Pages.TokenDisplayPage path="token/display" />
            <Pages.QRCodeDisplay path="token/qr" />
            <Pages.TrackStatusPage path="track_status" />
            <Pages.UserEmailVerification path="email_verification/:uid/:token" />
            <Pages.ResetPasswordConfirm path="password_reset_confirm/:uid/:token" />
            <Pages.ESignature path="/signature/:type/:id/:code/:guid" />
            <Pages.NotFoundPage default />
            <PrivateRoute
              idleTimeOutMinutes={idleTimeOutMinutes}
              idleTimeOutNoticeBeforeMinutes={idleTimeOutNoticeBeforeMinutes}
              as={isMobileDeviceBrowser ? MobileDeviceLayout : DesktopLayout}
              path="dashboard"
            >
              <Pages.DashboardPage path="/" />
              <Pages.OrganizationListPage path="/organizations" />
              <Pages.UserListPage path="/users" />
              <Pages.CustomersPage path="/customers" />
              <Pages.TicketListPage path="/tickets" />
              <Pages.TicketUpdatePage path="/ticket/:purchaseOrderNumber" />
              <Pages.TokenListPage path="/tokens" />
              <Pages.UserAccountApprove path="user_approve/:uid/:token" />
              <Pages.LoanerInventoryListPage path="/loaners" />
              <Pages.RepairInventoryListPage path="/repairs" />
              <Pages.PenaltyAmountPage user={user} path="/loaners_penalty" />
              <Pages.RepairInventoryStatsPage
                path="/invertory_stats"
                defaultFilters={{ inventory_type: 'repair' }}
              />
              <Pages.RepairInventoryStatsPage
                path="/loaner_stats"
                defaultFilters={{ inventory_type: 'loaner' }}
              />
              <Pages.NonSerializableInventoryListPage path="/non-serializable" />
              <Pages.ScheduleReportPage path="/reports" />
              <Pages.SupportPackagesPage path="/support_packages" />
              <Pages.UserProfilePage path="/profile" />
              <Pages.UserProfilePage path="/profile/:activeKey" />
              <Pages.OptionsManagementPage path="/options" />
              <Pages.LogoutPage path="/logout" />
            </PrivateRoute>
            <AdminOnlyRoute
              idleTimeOutMinutes={idleTimeOutMinutes}
              idleTimeOutNoticeBeforeMinutes={idleTimeOutNoticeBeforeMinutes}
              as={isMobileDeviceBrowser ? MobileDeviceLayout : DesktopLayout}
              path="admin"
            >
              <Pages.Analytics user={user} path="/analytics" />
              <Pages.GSXLogsListPage user={user} path="/gsx_log" />
            </AdminOnlyRoute>
          </ScrollToTop>
        </Router>
      </div>
    </div>
  )
}
